import { useMemo } from 'react';

import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';

import { LIVE_PREVIEW_TABS, LIVE_PREVIEW_TAB_KEYS } from './../lib/helpers';

const LivePreviewTabs = ({ activeKey, setActiveKey, letterType }) => {
  const items = useMemo(
    () =>
      LIVE_PREVIEW_TABS.filter(
        (tab) => tab.key === LIVE_PREVIEW_TAB_KEYS.PRE_AUTH_FORM || tab.key === letterType
      ).map((tab) => ({
        label: tab.label,
        value: tab.key
      })),
    [letterType]
  );

  const currentActive = activeKey === LIVE_PREVIEW_TAB_KEYS.PRE_AUTH_FORM ? activeKey : letterType;

  return (
    <div className="flex h-10 items-end gap-6 border-0 border-b border-solid border-b-neutral-200 bg-white px-4 py-2">
      <ToggleSwitch
        items={items}
        active={currentActive}
        onClick={(item) => setActiveKey(item.value)}
      />
    </div>
  );
};

export default LivePreviewTabs;
